import AdminClient from '@/api/AdminClient';
import eagerFetchImage from '@/helpers/eager-fetch-image';

export default class CollegeDetailsReport {
  constructor() {
    this.adminClient = null;
    this.schoolId = 0;

    this.loading = true;
    this.error = null;
    this.data = {};
  }

  async initialize($http, schoolId) {
    this.adminClient = new AdminClient($http);
    this.schoolId = schoolId;
    await this.fetch();
  }

  async fetch() {
    try {
      this.loading = true;

      const data = await this.adminClient.getCollegeAdminCollegeDetailsReport(
        this.schoolId
      );

      data.logoUrl = await eagerFetchImage(data.logoUrl);

      this.data = data;
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  }
}
